import projects from './projects'
import stats from './stats'

export default {
  namespaced: true,
  modules: {
    projects,
    stats,
  }
}
